export const NEWSLETTER_POPUP_DOM_EVENT_NAME = "activate-newsletter-popup";
